module.exports = __webpack_public_path__ + "static/media/cover-italy.905b5a05.jpg";